import { connect } from "react-redux";
import { TableBody } from "../components/TableBody";
import { actionConfirmation, changeCheck } from "../actions/actions";
import { doExecuteAction } from "../actions/thunks";
function mapStateToProps({ kptable }, { id }) {
    return {
        checked: kptable[id].checked,
        confirmation: kptable[id].confirmation,
        waiting: kptable[id].waiting,
        columnVisibility: kptable[id].columnVisibility,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onChangeCheck: (id, key, value) => dispatch(changeCheck(id, key, value)),
        onHandleAction: ({ id, datum, keyField, action }) => dispatch(doExecuteAction(id, datum, keyField, action)),
        onCancelAction: ({ id, datum, keyField }) => dispatch(actionConfirmation(id, datum, keyField)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TableBody);
